import { getLayout as getAppLayout } from '../AppLayout';

const ProfileLayout = ({ children }) => {
  return <>{children}</>;
};

export const getLayout = (page) => getAppLayout(<ProfileLayout>{page}</ProfileLayout>);

export default ProfileLayout;
